import { render, staticRenderFns } from "./recorddetail.vue?vue&type=template&id=f6deb624&scoped=true"
import script from "./recorddetail.vue?vue&type=script&lang=js"
export * from "./recorddetail.vue?vue&type=script&lang=js"
import style0 from "./recorddetail.vue?vue&type=style&index=0&id=f6deb624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6deb624",
  null
  
)

export default component.exports